/**
 * The email regex pattern used in validation rules of extended metadata.
 */
const emailRegex = '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$';

/**
 * The phone number regex pattern used in validation rules of extended metadata.
 */
const phoneNumberRegex = '^\\+[1-9][0-9]{1,14}$';

/**
 * The postcode regex pattern used in validation rules of extended metadata.
 */
const postcodeRegex = '^[A-Za-z]{1,2}[0-9][0-9A-Za-z]?[ ]?[0-9][A-Za-z]{2}$';

/**
 * The jsonElementName regex pattern used in validation rules of extended metadata.
 * Allows camelCase alphanumeric strings: must start with lowercase letter,
 * followed by any combination of letters (upper/lower) and numbers.
 * Examples: name, firstName, group1Name, fileURL, fieldName
 */
const jsonElementNameRegex = '^[a-z][a-zA-Z0-9]*$';

export const validationPatterns = {
  emailRegex,
  phoneNumberRegex,
  postcodeRegex,
  jsonElementNameRegex,
};
